import { useMemo, useState } from "react";

import {
  buildTypeFilterOptions,
  STATUS_FILTER_ID,
  TYPE_FILTER_ID,
} from "features/vaccineSettings/filters";

const matchesSelectedTypes = (row, typeKey, selectedTypes) =>
  selectedTypes.length === 0 || selectedTypes.includes(row[typeKey]);

const matchesSearchTerm = (row, searchKeys, searchTerm) =>
  !searchTerm ||
  searchKeys.some((key) =>
    String(row[key] ?? "")
      .toLowerCase()
      .includes(searchTerm)
  );

export const useVaccineListFilters = ({
  rows,
  statusFilter,
  matchesStatus,
  typeKey,
  searchKeys,
}) => {
  const [filters, setFilters] = useState({});
  const [searchValue, setSearchValue] = useState("");

  const handleFilterChange = (groupId, value) =>
    setFilters((previous) => ({ ...previous, [groupId]: value }));

  const filtersConfig = useMemo(() => {
    const typeOptions = buildTypeFilterOptions(rows, typeKey);
    const typeFilter = {
      id: TYPE_FILTER_ID,
      label: "Type",
      type: "multi",
      options: typeOptions,
    };

    return typeOptions.length > 0 ? [statusFilter, typeFilter] : [statusFilter];
  }, [rows, statusFilter, typeKey]);

  const filteredRows = useMemo(() => {
    const status = filters[STATUS_FILTER_ID] ?? null;
    const selectedTypes = Array.isArray(filters[TYPE_FILTER_ID])
      ? filters[TYPE_FILTER_ID]
      : [];
    const searchTerm = searchValue.trim().toLowerCase();

    return rows.filter(
      (row) =>
        (!status || matchesStatus(row, status)) &&
        matchesSelectedTypes(row, typeKey, selectedTypes) &&
        matchesSearchTerm(row, searchKeys, searchTerm)
    );
  }, [rows, filters, searchValue, matchesStatus, typeKey, searchKeys]);

  return {
    filtersConfig,
    filters: { value: filters, onChange: handleFilterChange },
    search: { value: searchValue, onChange: setSearchValue },
    filteredRows,
  };
};
